import React from "react";

export function highlightKeyword(text: string, keyword: string, className = "orange650") {
  const parts = text.split(keyword);
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 && <span className={className}>{keyword}</span>}
    </React.Fragment>
  ));
}
